export const PartnerUnitGridConfig = {
	grid: {
		height:500,
		gridId:'ProgramPartnerGrid',
		editable : false,
		selectable : true,
		filterable : true,
		resizable : true,
		noRecords : true,
		reorderable : false,
		columnMenu : true,
		sortable : true,
		pageSize: 10,
		groupable:false,
		scrollable:true
	},
	columns: {
		Id: {
			class: "id",
			dataName: 'Id',
			type: 'number',
			title: 'Partner Id',
			width: 100,
			hidden: true
		},
		PartnerID: {
			class: "value",
			dataName: 'PartnerID',
			type: 'number',
			title: 'Partner ID',
			width: 150,
			hidden: false,
			groupFooterTemplate: "<b>Total:</b>",
			footerTemplate: "<b>FMV Total:</b>",
			locked:false
		},
		Name: {
			class: "value",
			dataName: 'Name',
			type: 'string',
			title: 'Partner Name',
			width: 180,
			hidden: false,
			locked:false
		},
		PartnerTaxStatus: {
			class: "lookup",
			dataName: 'Partner/TaxStatus',
			type: 'string',
			title: 'Tax Status',
			width: 120,
			hidden: true
		},
		HireDate: {
			class: "value",
			dataName: 'HireDate',
			type: 'date',
			title: 'Hire Date',
			width: 150,
			hidden: true
		},
		LeaveDate: {
			class: "value",
			dataName: 'LeaveDate',
			type: 'date',
			title: 'Leave Date',
			width: 150,
			hidden: true
		},
		UnitClass: {
			class: "value",
			dataName: 'UnitClass',
			type: 'string',
			title: 'Unit Class',
			width: 150,
			hidden: false
		},
		VestingType: {
			class: "value",
			dataName: 'VestingType',
			type: 'string',
			title: 'Vesting Type',
			width: 150,
			hidden: false
		},
		Ownership:{
			class: "value",
			dataName: 'Ownership',
			type: 'percent',
			title: 'Economic Ownership',
			width: 220,
			hidden: false,
			template : '<span class="number-cell-ui">#= kendo.toString(Ownership) #' + ' %</span>',
			format : "{0:p}",
		},
		// PartnerType: {
		// 	class: "value",
		// 	dataName: 'PartnerType',
		// 	type: 'string',
		// 	title: 'Treasury/New',
		// 	width: 120,
		// 	hidden: true
		// },
		StandardIssuance: {
			class: "value",
			dataName: 'StandardIssuance',
			type: 'number',
			title: 'Standard Issuance',
			width: 220,
			hidden: true,
			template: "<span class='number-cell-ui'>#=kendo.toString(StandardIssuance)#</span>",
			format: "{0:n}",
			aggregates: ["sum"],
			footerTemplate: "<span class='number-cell-ui'><b>#=kendo.toString(sum, 'n')#</b></span>",
			groupFooterTemplate: "<span class='number-cell-ui'><b>#=kendo.toString(sum, 'n')#</b></span>"
		},
		StandardTransfer: {
			class: "value",
			dataName: 'StandardTransfer',
			type: 'number',
			title: 'Standard Transfer',
			width: 220,
			template: "<span class='number-cell-ui'>#=kendo.toString(StandardTransfer)#</span>",
			hidden: true,
			format: "{0:n}",
			aggregates: ["sum"],
			footerTemplate: "<span class='number-cell-ui'><b>#=kendo.toString(sum, 'n')#</b></span>",
			groupFooterTemplate: "<span class='number-cell-ui'><b>#=kendo.toString(sum, 'n')#</b></span>"
		},
		StandardForfeiture: {
			class: "value",
			dataName: 'StandardForfeiture',
			type: 'number',
			title: 'Standard Forfeiture',
			width: 220,
			template: "<span class='number-cell-ui'>#=kendo.toString(StandardForfeiture)#</span>",
			hidden: true,
			format: "{0:n}",
			aggregates: ["sum"],
			footerTemplate: "<span class='number-cell-ui'><b>#=kendo.toString(sum, 'n')#</b></span>",
			groupFooterTemplate: "<span class='number-cell-ui'><b>#=kendo.toString(sum, 'n')#</b></span>"
		},
		StandardTotal: {
			class: "value",
			dataName: 'StandardTotal',
			type: 'number',
			title: 'Standard Total',
			width: 200,
			hidden: true,
			format: "{0:n}",
			aggregates: ["sum"],
			footerTemplate: "<b>#=kendo.toString(sum, 'n')#</b>",
			groupFooterTemplate: "<b>#=kendo.toString(sum, 'n')#</b>"
		},
		SupplementalIssuance: {
			class: "value",
			dataName: 'SupplementalIssuance',
			type: 'number',
			title: 'Supplemental/Deal Issuance',
			width: 250,
			template: "<span class='number-cell-ui'>#=kendo.toString(SupplementalIssuance)#</span>",
			hidden: true,
			format: "{0:n}",
			aggregates: ["sum"],
			footerTemplate: "<span class='number-cell-ui'><b>#=kendo.toString(sum, 'n')#</b></span>",
			groupFooterTemplate: "<span class='number-cell-ui'><b>#=kendo.toString(sum, 'n')#</b></span>"
		},
		SupplementalTransfer: {
			class: "value",
			dataName: 'SupplementalTransfer',
			type: 'number',
			title: 'Supplemental/Deal Transfer',
			width: 250,
			template: "<span class='number-cell-ui'>#=kendo.toString(SupplementalTransfer)#</span>",
			hidden: true,
			format: "{0:n}",
			aggregates: ["sum"],
			footerTemplate: "<span class='number-cell-ui'><b>#=kendo.toString(sum, 'n')#</b></span>",
			groupFooterTemplate: "<span class='number-cell-ui'><b>#=kendo.toString(sum, 'n')#</b></span>"
		},
		SupplementalForfeiture: {
			class: "value",
			dataName: 'SupplementalForfeiture',
			type: 'number',
			title: 'Supplemental/Deal Forfeiture',
			width: 250,
			template: "<span class='number-cell-ui'>#=kendo.toString(SupplementalForfeiture)#</span>",
			hidden: true,
			format: "{0:n}",
			aggregates: ["sum"],
			footerTemplate: "<span class='number-cell-ui'><b>#=kendo.toString(sum, 'n')#</b></span>",
			groupFooterTemplate: "<span class='number-cell-ui'><b>#=kendo.toString(sum, 'n')#</b></span>"
		},
		SupplementalTotal: {
			class: "value",
			dataName: 'SupplementalTotal',
			type: 'number',
			title: 'Supplemental/Deal Total',
			width: 250,
			hidden: true,
			format: "{0:n}",
			aggregates: ["sum"],
			footerTemplate: "<b>#=kendo.toString(sum, 'n')#</b>",
			groupFooterTemplate: "<b>#=kendo.toString(sum, 'n')#</b>"
		},
		TotalUnits: {
			class: "value",
			dataName: 'Total',
			type: 'number',
			title: 'Total Units',
			width: 150,
			template: "<span class='number-cell-ui'>#=kendo.toString(TotalUnits)#</span>",
			hidden: false,
			format: "{0:n}",
			aggregates: ["sum"],
			footerTemplate: "<span class='number-cell-ui'><b>#=kendo.toString(sum, 'n')#</b></span>",
			groupFooterTemplate: "<span class='number-cell-ui'><b>#=kendo.toString(sum, 'n')#</b></span>"
		},
		AdjustedTotalUnits: {
			class: "value",
			dataName: 'AdjustedTotalUnits',
			type: 'number',
			title: 'Adjusted Total Units',
			width: 200,
			template: "<span class='number-cell-ui'>#=kendo.toString(AdjustedTotalUnits)#</span>",
			hidden: false,
			format: "{0:n}",
			aggregates: ["sum"],
			footerTemplate: "<span class='number-cell-ui'><b>#=kendo.toString(sum, 'n')#</b></span>",
			groupFooterTemplate: "<span class='number-cell-ui'><b>#=kendo.toString(sum, 'n')#</b></span>"
		},
		TaxOwnership:{
			class: "value",
			dataName: 'TaxOwnership',
			type: 'percent',
			title: 'Tax Ownership',
			width: 180,
			hidden: false,
			template: "<span class='number-cell-ui'>#=kendo.toString(TaxOwnership, 'p')#</span>",
			format : "{0:p}",
			aggregates: ["sum"],
			footerTemplate: "<span class='number-cell-ui'><b>#=kendo.toString(sum, 'p')#</b></span>",
			groupFooterTemplate: "<span class='number-cell-ui'><b>#=kendo.toString(sum, 'p')#</b></span>"
		},
		FMVOwnership:{
			class: "value",
			dataName: 'FMVOwnership',
			type: 'percent',
			title: 'FMV Ownership',
			width: 180,
			template: "<span class='number-cell-ui'>#=kendo.toString(FMVOwnership, 'p')#</span>",
			hidden: false,
			format : "{0:p}",
			aggregates: ["sum"],
			footerTemplate: "<span class='number-cell-ui'><b>#=kendo.toString(sum, 'p')#</b></span>",
			groupFooterTemplate: "<span class='number-cell-ui'><b>#=kendo.toString(sum, 'p')#</b></span>"
		},
		ProgProjectedValue: {
			class: "value",
			dataName: 'ProgProjectedValue',
			type: 'number',
			title: 'Program Projected Value',
			//template: '#=kendo.toString(ProjectedValue, "c")#',
			//template: '#if(ProjectedValue === null){##}else{# #=kendo.toString(ProjectedValue, "c")#  #}#',
			//template: '<span class="number-cell-ui">#if(ProgProjectedValue === null){##}else{# #=kendo.toString(ProgProjectedValue, "c")#  #}#</span>',
			template: '<span class="number-cell-ui">#=kendo.format("{0:n0}", ProgProjectedValue!=null?ProgProjectedValue:0)#</span>',
			width: 140,
			hidden: true,
			readOnly: false
		},
		PreviousUnitDistribution: {
			class: "value",
			dataName: 'PreviousUnitDistribution',
			type: 'number',
			title: 'Previous Unit Distributions (Cumulative)',
			//template: '<span class="number-cell-ui">#if(HideNumberOnFMVS.indexOf("PreviousUnitDistribution") >= 0) {# - #} else {# #=kendo.format("{0:n0}", PreviousUnitDistribution!=null?PreviousUnitDistribution:0)# #}#</span>',
			template: '<span class="number-cell-ui">#=kendo.format("{0:n0}", PreviousUnitDistribution!=null?PreviousUnitDistribution:0)#</span>',
			width: 200,
			hidden: false,
			editable: false,
			aggregates: ["sum"],
			footerTemplate: '<span class="number-cell-ui">#=kendo.format("{0:n0}", sum!=null?sum:0)#</span>'
		},
		ProjectedUnrealizedValue: {
			class: "value",
			dataName: 'ProjectedUnrealizedValue',
			type: 'number',
			title: 'Projected Unrealized Value (Undiscounted)',
			//template: '<span class="number-cell-ui">#if(HideNumberOnFMVS.indexOf("ProjectedUnrealizedValue") >= 0) {# - #} else {# #=kendo.format("{0:n0}", ProjectedUnrealizedValue!=null?ProjectedUnrealizedValue:0)# #}#</span>',
			//template: '<span class="number-cell-ui">#if((ProjectedUnrealizedValue) >= 0) {# - #} else {# #=kendo.format("{0:n0}", ProjectedUnrealizedValue!=null?ProjectedUnrealizedValue:0)# #}#</span>',
			template: '<span class="number-cell-ui">#=kendo.format("{0:n0}", ProjectedUnrealizedValue!=null?ProjectedUnrealizedValue:0)#</span>',
			width: 200,
			hidden: false,
			editable: false,
			aggregates: ["sum"],
			footerTemplate: '<span class="number-cell-ui">#=kendo.format("{0:n0}", sum!=null?sum:0)#</span>'
		},
		TotalPotentialPreTaxValuePercentChange: {
			class: "value",
			dataName: 'TotalPotentialPreTaxValuePercentChange',
			type: 'number',
			title: 'Total Potential Pre-Tax Value Percentage Change Since Prior Statement',
			//template: '<span class="number-cell-ui">#if(TotalPotentialPreTaxValuePercentChange == null){# #if(HideNumberOnFMVS.indexOf("TotalPotentialPreTaxValuePercentChange") >= 0) {# - #} else {# N/A #}# #}else{# #if(HideNumberOnFMVS.indexOf("TotalPotentialPreTaxValuePercentChange") >= 0) {# - #} else {# #=kendo.toString(TotalPotentialPreTaxValuePercentChange, "p1")# #}# #}#</span>',
			//template: '<span class="number-cell-ui">#if(TotalPotentialPreTaxValuePercentChange == null){# #if((TotalPotentialPreTaxValuePercentChange) >= 0) {# - #} else {# N/A #}# #}else{# #if((TotalPotentialPreTaxValuePercentChange) >= 0) {# - #} else {# #=kendo.toString(TotalPotentialPreTaxValuePercentChange, "p1")# #}# #}#</span>',
			template: '<span class="number-cell-ui">#=kendo.toString(TotalPotentialPreTaxValuePercentChange, "p1")#</span>',
			width: 250,
			hidden: false,
			editable: false,
		},
		ProgCurrentValue: {
			class: "value",
			dataName: 'ProgCurrentValue',
			type: 'number',
			title: 'Program Current Value',
			//template: '#=kendo.toString(CurrentValue, "c")#', 
			//template: '#if(CurrentValue === null){##}else{# #=kendo.toString(CurrentValue, "c")#  #}#', 
			//template: '<span class="number-cell-ui">#if(ProgCurrentValue === null){##}else{# #=kendo.toString(ProgCurrentValue, "c")#  #}#</span>', 
			template: '<span class="number-cell-ui">#=kendo.format("{0:n0}", ProgCurrentValue!=null?ProgCurrentValue:0)#</span>',
			width: 140,
			hidden: true,
			readOnly: false
		}
		,
		CurrentValue: {
			class: 'value',
			dataName: 'CurrentValue',
			type: 'number',
			title: 'Current Values (Discounted)',
			//template: '<span class="number-cell-ui">#if(HideNumberOnFMVS.indexOf("CurrentValue") >= 0) {# - #} else {# #=kendo.format("{0:n0}", CurrentValue!=null?CurrentValue:0)# #}#</span>',
			template: '<span class="number-cell-ui">#=kendo.format("{0:n0}", CurrentValue!=null?CurrentValue:0)#</span>',
			width: 150,
			hidden: false,
			editable: false,
			aggregates: ["sum"],
			footerTemplate: '<span class="number-cell-ui">#=kendo.format("{0:n0}", sum!=null?sum:0)#</span>'
		}
		,
		TotalCurrentPreTaxValuePercentChange: {
			class: "value",
			dataName: 'TotalCurrentPreTaxValuePercentChange',
			type: 'number',
			title: 'Total Current Pre-Tax Value Percentage Change Since Prior Statement',
			//template: '<span class="number-cell-ui">#if(TotalCurrentPreTaxValuePercentChange == null){# #if(HideNumberOnFMVS.indexOf("TotalCurrentPreTaxValuePercentChange") >= 0) {# - #} else {# N/A #}# #}else{# #if(HideNumberOnFMVS.indexOf("TotalCurrentPreTaxValuePercentChange") >= 0) {# - #} else {# #=kendo.toString(TotalCurrentPreTaxValuePercentChange, "p1")#  #}# #}#</span>',
			template: '<span class="number-cell-ui">#=kendo.toString(TotalCurrentPreTaxValuePercentChange, "p1")#</span>',
			width: 250,
			hidden: false,
			editable: false,
		}
		
	}
}

export const PartnerUnitToolbarConfig = {
	list: 'ToolBarItems',
	DisableBaseDefaultItems:[
		{name: "Grouping"},
		{name: "Export",child:{name:"ExportSelected"}},
		{name: "SaveViews"}
    ],
	items: [
			{
				template: '<space><input type="radio" name="View" id="summaryView" checked/> Summary View  <space><input type="radio" name="View" id="detailView"/> Detail View',
				attributes: { "class": "radioButton  float-right-btn" } 
				//Class = 'radioButton' is required for using Radio Buttons in ToolBar
			},
			// {
			// 		template: '<Label>As of :</Label><input id="dateAsOfDate" />', 
			// 		overflow: "never",
			// 		attributes: { "class": " float-right-btn" }
			// },
			
	]
}

export const ProgramInfoConfig = {
	parent: {
		Id: "",
		ProgramID:"",
		Title: "",
		Alias: "",
		EIN: "",
		FormationDate: "",
		InitialAwardDate: "",
		IncomeSource: "",
		FinalCloseDate: "",
		MultiClass: "",
		StateSource: "",
		IncomeSource: "",
		Note: "",
		InvestmentId: "",
		InvestmentTitle:"",
	},
	children: {
		UnitClass: [],
		VestingSchedule: []
	}
}

